/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/',
    name: 'Campañas',
    slug: 'campaigns',
    icon: 'BookIcon',
    checkPermission: 'use_accounting_panel_campaigns'
  },
  {
    url: '/clients',
    name: 'Clientes',
    slug: 'clients',
    icon: 'UsersIcon',
    checkPermission: 'use_accounting_panel_clients'
  },
  {
    url: '/billing',
    name: 'Facturación',
    slug: 'billing',
    icon: 'ClipboardIcon',
    checkPermission: 'use_accounting_panel_billing'
  },
  {
    url: '/charges',
    name: 'Cobros',
    slug: 'charges',
    icon: 'DollarSignIcon',
    checkPermission: 'use_accounting_panel_charges'
  },
  {
    url: '/closings',
    name: 'Cierres',
    slug: 'closings',
    icon: 'InboxIcon',
    checkPermission: 'use_accounting_panel_closures'
  },
  {
    url: '/payments',
    name: 'Pagos',
    slug: 'payments',
    icon: 'CreditCardIcon',
    checkPermission: 'use_accounting_panel_payments'
  },
  {
    url: '/stats',
    name: 'Estadísticas',
    slug: 'stats',
    icon: 'ActivityIcon'
  },
  {
    url: '/screens',
    name: 'Pantallas',
    slug: 'screens',
    icon: 'MonitorIcon',
    checkPermission: 'use_accounting_panel_screens'
  },
  {
    url: '/licenses',
    name: 'Licencias',
    slug: 'licenses',
    icon: 'StarIcon',
    checkPermission: 'show_licenses'
  },
  {
    url: '/kpis',
    name: 'KPIs',
    slug: 'kpis',
    icon: 'BarChart2Icon',
    checkPermission: 'show_licenses'
  },
  {
    url: '/goals',
    name: 'Objetivos',
    slug: 'goals',
    icon: 'CrosshairIcon'
  }
  // {
  //   url: '/page2',
  //   name: 'Page 2',
  //   slug: 'page2',
  //   icon: 'FileIcon'
  // }
]
